// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2PTdj","loaderOuter":"PageOverlayLoader_loaderOuter__foiT9"};